module.exports = __webpack_public_path__ + "img/14.662a97b4.jpg";